/**
 * Protocolo de input que viaja por el DataChannel.
 *
 * Las coordenadas van SIEMPRE normalizadas 0–1 respecto al área capturada, nunca
 * en píxeles: los dos extremos tienen resoluciones y densidades distintas (Retina
 * vs. no-Retina, monitores dispares), y solo lo normalizado sobrevive al viaje.
 * El agente las multiplica por el tamaño de SU pantalla al inyectar.
 *
 * Estos mensajes comparten el DataChannel con el ping/pong de control, pero son
 * un tipo aparte: el ping/pong mide latencia y es simétrico; el input es
 * unidireccional (cliente → agente) y de otra frecuencia. Mantenerlos separados
 * deja cada `switch` con su propio dominio cerrado.
 */
export const MODIFIERS = ['cmd', 'shift', 'alt', 'ctrl'];
export function encodeInputMessage(message) {
    return JSON.stringify(message);
}
//# sourceMappingURL=input.js.map